import React from 'react';
import {
  type ImperativePanelGroupHandle,
  PanelGroup,
} from 'react-resizable-panels';

export const ResizableGroup = React.forwardRef<
  ImperativePanelGroupHandle,
  {
    children: React.ReactNode;
    widthPersistKey?: string;
    className?: string;
  }
>(({ children, widthPersistKey, className }, ref) => {
  return (
    <PanelGroup
      ref={ref}
      direction="horizontal"
      autoSaveId={widthPersistKey}
      className={className}
    >
      {children}
    </PanelGroup>
  );
});
ResizableGroup.displayName = 'ResizableGroup';
